import {
  Rocket, Gift, Link as LinkIcon, BarChart3, LayoutDashboard,
  Mic, Users, Handshake, Megaphone, CheckCircle, Heart,
  ClipboardList, MessageCircle, Share2, Calendar, FileText, MapPin
} from 'lucide-react';

const iconMap: Record<string, React.ReactNode> = {
  'rocket': <Rocket className="h-10 w-10 text-primary" />,
  'gift': <Gift className="h-10 w-10 text-primary" />,
  'link': <LinkIcon className="h-10 w-10 text-primary" />,
  'bar-chart-3': <BarChart3 className="h-10 w-10 text-primary" />,
  'layout-dashboard': <LayoutDashboard className="h-10 w-10 text-primary" />,
  'mic': <Mic className="h-10 w-10 text-primary" />,
  'users': <Users className="h-10 w-10 text-primary" />,
  'handshake': <Handshake className="h-10 w-10 text-primary" />,
  'megaphone': <Megaphone className="h-10 w-10 text-primary" />,
  'check-circle': <CheckCircle className="h-10 w-10 text-primary" />,
  'heart': <Heart className="h-10 w-10 text-primary" />,
  'clipboard-list': <ClipboardList className="h-10 w-10 text-primary" />,
  'message-circle': <MessageCircle className="h-10 w-10 text-primary" />,
  'share-2': <Share2 className="h-10 w-10 text-primary" />,
  'calendar': <Calendar className="h-10 w-10 text-primary" />,
  'file-text': <FileText className="h-10 w-10 text-primary" />,
  'map-pin': <MapPin className="h-10 w-10 text-primary" />,
};

export const getIconByName = (name: string): React.ReactNode => {
  return iconMap[name] || <Rocket className="h-10 w-10 text-primary" />;
};
